<template>
  <div class="header">
    <div class="pagew header-box">
      <!-- logo区域 -->
      <div class="logo_content">
        <!--        湖南旭麓新材料科技有限公司-->
        <img src="@/assets/other/logo.jpg" alt="" />
      </div>
      <!-- 顶部导航菜单区域 -->
      <div class="nav-list">
        <router-link class="nav-btn" to="/homepage">&nbsp&nbsp&nbsp首页&nbsp&nbsp&nbsp</router-link>
        <router-link class="nav-btn" to="/workspace">公司简介</router-link>
        <router-link class="nav-btn" to="/Work/list">产品中心</router-link>
        <router-link class="nav-btn" to="/cooperation">定制合成</router-link>
        <!-- <router-link class="nav-btn" to="/workspace">关于我们</router-link> -->
        <!-- <router-link class="nav-btn setactive" to="/workspace"
          >关于我们
          <div class="select-div select-about-div">
            <ul>
              <li>
                <router-link to="/workspace">公司简介</router-link>
              </li>
              <li>
                <router-link to="/recruitment">招贤纳士</router-link>
              </li>
            </ul>
          </div>
        </router-link> -->
        <router-link class="nav-btn" to="/news">新闻中心</router-link>
        <router-link class="nav-btn" to="/Contactus">联系我们</router-link>
        <router-link class="nav-btn" to="/recruitment">人才招聘</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: String,
      default: "/homepage"
    }
  },
  data() {
    return {
      // activeIndex: "/homepage",
      showQr: false
    };
  },
  methods: {
    onShowQrCode() {
      this.showQr = true;
    },
    onHide() {
      this.showQr = false;
    },
    handleSelect(key, keyPath) {
      this.$router.push(key);
    },
    goLogin() {
      window.location.href = "http://8.134.120.63/";
    },
    goregister() {
      window.location.href = "http://8.134.120.63/register";
    }
  }
};
</script>

<style lang="scss" scoped>
.qr-img {
  position: absolute;
  right: 100px;
  top: 40px;
  width: 120px;
  left: -30px;
}
.qr-img::before {
  content: "";
  width: 0;
  height: 0;
  border-width: 10px;
  border-color: transparent transparent #fff;
  border-style: solid;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -18px;
}
.login {
  background-color: transparent;
  border: 1px solid #5097d5;
  width: 90px;
  height: 40px;
  color: #5097d5;
}
.regiest {
  width: 100px;
  height: 40px;
  background-color: #5097d5;
  color: #ffffff;
}
.el-menu {
  background-color: none;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.header {
  // background-color: rgba($color: #fff, $alpha: 0.65);
  background-color: #fff;
  width: 100%;
  height: 82px;
  position: fixed;
  z-index: 500;
  top: 0;
  left: 0;
  // box-shadow: 0 2px 10px 0 rgb(70 130 242 / 20%);

  .logo_content {
    //width: 100px;
    margin-right: 30px;
    display: flex;
    justify-content: flex-end;
  }
}
.header-box {
  display: flex;
  height: 100%;
  justify-content: space-around;
  align-items: center;
}
.nav-list {
  font-size: 0;
}
.nav-btn {
  line-height: 82px;
  padding: 0 10px;
  display: inline-block;
  font-size: 14px;
  margin-right: 1px;
  min-width: 38px;
  font-weight: 550;
}
.help-btn {
  position: relative;
  a {
    width: 60px;
  }
}
</style>
<style lang="scss">
.nav-list .nav-btn:hover,
.nav-btn.router-link-active {
  transition: all 1s;
  background: url("../../assets/image/nav_bg.png") center bottom #5097d5;
  color: #fff;
}
.el-menu-demo .nav-btn:hover {
  transition: all 1s;
  background: url("../../assets/image/nav_bg.png") center bottom #5097d5;
  color: #fff;
}

.select-div ul li {
  cursor: pointer;
  list-style: none;
  line-height: 60px;
  width: 120px;
  a {
    padding: 8px 5px;
    font-size: 14px;
    font-weight: 550;
  }
}

.select-div ul li:hover {
  transition: all 1s;
  background: #5097d5;
  a {
    color: #fff;
  }
}

.select-cooperation-div {
  background-color: rgba($color: #fff, $alpha: 0.65);
  position: absolute;
  top: 82px;
  left: 805px;
  display: none;
}

.select-about-div {
  background-color: rgba($color: #fff, $alpha: 0.65);
  position: absolute;
  top: 82px;
  left: 882px;
  display: none;
}

.setactive:hover {
  transition: all 1s;
  .select-div {
    transition: all 1s;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue